var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWYtb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    viewBox: "0 0 48 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5219 7.4001C47.5219 7.4001 47.0531 4.09072 45.6094 2.6376C43.7812 0.725098 41.7375 0.715722 40.8 0.603222C34.0875 0.115722 24.0094 0.115723 24.0094 0.115723H23.9906C23.9906 0.115723 13.9125 0.115722 7.2 0.603222C6.2625 0.715722 4.21875 0.725098 2.39062 2.6376C0.946875 4.09072 0.4875 7.4001 0.4875 7.4001C0.4875 7.4001 0 11.2907 0 15.172V18.8095C0 22.6907 0.478125 26.5813 0.478125 26.5813C0.478125 26.5813 0.946875 29.8907 2.38125 31.3438C4.20937 33.2563 6.60938 33.1907 7.67813 33.397C11.5219 33.7626 24 33.8751 24 33.8751C24 33.8751 34.0875 33.8563 40.8 33.3782C41.7375 33.2657 43.7812 33.2563 45.6094 31.3438C47.0531 29.8907 47.5219 26.5813 47.5219 26.5813C47.5219 26.5813 48 22.7001 48 18.8095V15.172C48 11.2907 47.5219 7.4001 47.5219 7.4001ZM19.0406 23.2251V9.73447L32.0062 16.5032L19.0406 23.2251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWYtb);
export default __webpack_public_path__ + "static/media/w-ytb.7440f367091eba8bbaa20fa7de72fe00.svg";
export { ForwardRef as ReactComponent };